import {Component} from '@angular/core';
import {TitleService} from '../../../../shared/services/title.service';

@Component({
    selector: 'app-tac',
    templateUrl: './tac.component.html',
    styleUrls: ['./tac.component.scss', '../../../containers/content-page/content-page.component.scss']

})
export class TacComponent {

    public constructor(private titleService: TitleService) {
        this.titleService.setTitle('Terms and conditions');
    }
}
